import { Component, OnChanges, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { TaskListService } from "../../_services/task-list.service";
import { FormGroup, FormControl, Validators } from "@angular/forms";

@Component({
  selector: "task-list",
  templateUrl: "./task-list.component.html",
  styleUrls: ["./task-list.component.css"],
})
export class TaskListComponent implements OnInit, OnChanges {
  @Input() offerId: number;
  @Input() listOnly: boolean;
  @Output() created: EventEmitter<number> = new EventEmitter<number>();

  private tasks: object[];
  private is_admin: false;
  private creating: boolean = false;

  new_task = new FormGroup({
    content: new FormControl("", [Validators.required]),
  });

  constructor(private service: TaskListService) {}

  ngOnInit() {
    this.getTaskList();
  }

  ngOnChanges() {
    this.getTaskList();
  }
  getTaskList() {

    if (this.offerId) {
      let offer_id = this.offerId ? this.offerId : null;
      this.service.getTasks(offer_id).subscribe((response) => {
        this.tasks = response.tasks;
        this.is_admin = response.is_admin;
      });
    }
  }

  setContent(event) {
    var value = event.target.value;
    this.new_task.patchValue({ content: value });
  }

  editTask(event) {
    event.target.parentElement.getElementsByClassName("no-edit-task")[0].style =
      "display: none;"; // Hide the displayed Task
    event.target.parentElement.getElementsByClassName("edit-task")[0].style =
      "display: auto;"; // Show it's edit Form
    event.target.parentElement
      .getElementsByClassName("edit-task")[0]
      .getElementsByTagName("INPUT")[0]
      .focus(); // Focus the Input
    event.target.parentElement
      .getElementsByClassName("edit-task")[0]
      .getElementsByTagName("INPUT")[0]
      .select(); // Select the content to direct edit
  }

  validEdit(event) {
    if (event.keyCode === 13) {
      // If ENTER pressed, trigger the click on the Update button
      event.target.parentElement.getElementsByTagName("BUTTON")[0].click();
    }
  }

  addTask(event) {
    this.creating = true;
  }

  createTask(event) {
    this.service
      .createTask({ id: this.offerId, content: this.new_task.value.content })
      .subscribe((response) => {
        this.getTaskList();
        this.new_task.patchValue({ content: "" });
        event.target.parentElement.parentElement.style = "display: none;";
        this.created.emit(this.tasks.length);
        this.creating = false;
      });
  }

  deleteTask(id) {
    this.service.deleteTask(id).subscribe((response) => {
      console.log("Deleted");
      this.getTaskList();
    });
  }

  updateTask(event) {
    if (event.target.tagName == "I") {
      var task_label = event.target.parentElement.parentElement.parentElement;
    } else if (event.target.tagName == "INPUT") {
      var task_label = event.target.parentElement;
    } else {
      var task_label = event.target.parentElement.parentElement;
    }
    task_label.getElementsByClassName("no-edit-task")[0].style =
      "display: auto;";
    task_label.getElementsByClassName("edit-task")[0].style = "display: none;";
    // Get Task Params
    var id = task_label.getElementsByClassName("task-checkbox")[0].id;
    var checked = task_label.getElementsByClassName("task-checkbox")[0].checked;
    var content = task_label.getElementsByClassName("task-content")[0].value;

    this.service
      .updateTask({ id: id, checked: checked, content: content })
      .subscribe((response) => {
        this.getTaskList();
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/task-list/task-list.component.ts